<div class="grid-container">
	<div class="grid-x grid-margin-x" [formGroup]="formGroup">
		<div class="cell small-6 text-align-right">
			<button (click)="save()" class="button" [disabled]="formGroup?.invalid || parseControl?.pristine">Save</button>
		</div>
		<div class="cell small-6 text-align-left">
			<button (click)="cancel()" class="button">Cancel</button>
		</div>
		<div class="cell small-12 bold">
			Select an Entity:
		</div>
		<div class="cell small-12">
			<text-loader [run]="allEntities == null || allEntities.length <= 1" [interval]="1000" [text]="'Loading Entities'" [tickType]="'.'"></text-loader>
			<select *ngIf="allEntities.length > 1" formControlName="entity">
				<option *ngFor="let entity of allEntities" [ngValue]="entity.id">{{entity.entityName}}</option>
			</select>
		</div>
		<div class="cell small-12 bold">
			Current File Parser:
		</div>
		<div class="cell small-12" *ngFor="let prop of parser; let i = index">
			<parser-format-display [model]="prop" [appendComma]="i !== parser.length - 1"></parser-format-display>
		</div>
		<div class="cell small-12 bold">
			Updated Parser:
		</div>
		<div class="cell small-12" *ngFor="let prop of updatedParser; let i = index">
			<button (click)="deleteProperty(i)">
				<svg-icon icon="icon-trash" class="tiny gray"></svg-icon>
			</button>
			<parser-format-display [model]="prop" [appendComma]="i !== updatedParser.length - 1"></parser-format-display>
		</div>
	</div>
    <div *ngIf="entity !== _defaultEntity.id"class="grid-x">
        <div class="cell small-6">
            <span class="bold">Available Properties:</span>
        </div>
        <div class="cell small-6 text-align-left">
            <help-text [helpText]="propertyInfoText"></help-text>
        </div>
    </div>
    <accordion *ngFor="let property of properties; let i = index">
            <accordion-panel>
                <div panel-header>{{property.propertyName}}</div>
                <div>
                    <entity-property [property]="property" [index]="i" (propertyAdded)="addToParser($event)"></entity-property>
                </div>
            </accordion-panel>
    </accordion>
</div>
